import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandCityCloud({
    height = 28,
    width = 90,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'provider-citycloud-brand-logo'
                    : 'provider-citycloud-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandCityCloud"
            width={width}
        />
    );
}

export default AppLogoBrandCityCloud;
